<template>
    <div class="index-faq">
        <Container width="landing">
            <h2 class="index-faq__title">
                Остались вопросы?
            </h2>
            <div class="index-faq__subtitle">
                Мы ответили на самые популярные
            </div>

            <div class="index-faq__grid">
                <template v-if="isMobileOrTablet">
                    <WBAccordion v-for="(faq, index) in props.faqs"
                                 :id="index"
                                 :key="index"
                                 theme="white"
                                 arrow-type="plus"
                                 outside-control
                                 padding="large"
                                 :is-open="index === openedAccordionIndex"
                                 @toggle="toggleAccordion"
                    >
                        <template #title>
                            <div class="index-faq__heading">
                                {{ faq.title }}
                            </div>
                        </template>
                        <template #content>
                            <div class="index-faq__content">
                                {{ faq.text }}
                            </div>
                        </template>
                    </WBAccordion>
                </template>
                <template v-else>
                    <div class="index-faq__column">
                        <WBAccordion v-for="faq in faqItems.even"
                                     :id="faq.index"
                                     :key="faq.index"
                                     theme="white"
                                     arrow-type="plus"
                                     padding="large"
                                     outside-control
                                     :is-open="faq.index === openedAccordionIndex"
                                     @toggle="toggleAccordion"
                        >
                            <template #title>
                                <div class="index-faq__heading">
                                    {{ faq.title }}
                                </div>
                            </template>
                            <template #content>
                                <div class="index-faq__content">
                                    {{ faq.text }}
                                </div>
                            </template>
                        </WBAccordion>
                    </div>
                    <div class="index-faq__column">
                        <WBAccordion v-for="faq in faqItems.odd"
                                     :id="faq.index"
                                     :key="faq.index"
                                     theme="white"
                                     arrow-type="plus"
                                     padding="large"
                                     outside-control
                                     :is-open="faq.index === openedAccordionIndex"
                                     @toggle="toggleAccordion"
                        >
                            <template #title>
                                <div class="index-faq__heading">
                                    {{ faq.title }}
                                </div>
                            </template>
                            <template #content>
                                <div class="index-faq__content">
                                    {{ faq.text }}
                                </div>
                            </template>
                        </WBAccordion>
                    </div>
                </template>
            </div>
        </Container>
    </div>
</template>

<script setup lang="ts">
    import type { IndexFaqItem } from '~/src/shared/components/pages/index/mock/indexFaq'
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import { useAccordion } from '~/src/shared/components/ui/accordion/useWBAccordion'
    import { useWindowStore } from '~/src/shared/pinia/useWindowStore'

    const props = defineProps<{
        faqs: IndexFaqItem[]
    }>()

    const windowStore = useWindowStore()
    const isMobileOrTablet = computed(() => windowStore.isMobileOrTablet)

    const faqItems = computed(() => {
        return props.faqs.reduce((acc, el, index) => {
            el.index = index

            if (index % 2 === 0) {
                acc.even.push(el)
            } else {
                acc.odd.push(el)
            }
            return acc
        }, { even: [], odd: [] } as { even: IndexFaqItem[], odd: IndexFaqItem[] })
    })

    const { accordionIndex: openedAccordionIndex, toggle: toggleAccordion } = useAccordion()
</script>

<style scoped lang="scss">
.index-faq {
        padding: 100px 0 60px;

        @include respond-to(mobile) {
            padding: 40px 0;
        }

        &__title {
            @include mulish40b;

            @include respond-to(mobile) {
                @include mulish24b;
            }
        }

        &__subtitle {
            @include mulish32b;

            margin-top: 6px;
            color: var(--grey-400);

            @include respond-to(mobile) {
                @include mulish20b;
            }
        }

        &__grid {
            display: flex;
            gap: 20px 32px;
            margin-top: 40px;

            @include respond-to(tablet) {
                flex-flow: column;
            }

            @include respond-to(mobile) {
                margin-top: 24px;
                gap: 12px 32px;
            }
        }

        &__column {
            display: grid;
            width: 100%;
            height: 100%;
            gap: 20px;

            @include respond-to(mobile) {
                gap: 12px;
            }
        }

        &__heading {
            @include manrope16sb;
        }

        &__content {
            @include manrope16r;
        }
    }
</style>
